<template>
  <div class="neutrino-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$P(να→νβ) = sin²(2θ) sin²(Δm²L/4E)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item" :class="activeFlavor.color">
             <label>当前味态 (Flavor)</label>
             <span class="val">{{ activeFlavor.name }}</span>
          </div>
          <div class="hud-item cyan">
            <label>飞行距离 L</label>
            <span class="val">{{ dist.toFixed(1) }} km</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 500 240" preserveAspectRatio="xMidYMid meet">
          <!-- 背景星空模拟 -->
          <circle v-for="i in 20" :key="i" :cx="Math.random()*500" :cy="Math.random()*240" r="0.5" fill="#fff" opacity="0.3" />

          <!-- 中微子飞行波束 (概率云图) -->
          <defs>
            <radialGradient id="nu-grad">
              <stop offset="0%" :style="`stop-color:${activeFlavor.hex};stop-opacity:1`" />
              <stop offset="100%" style="stop-color:#000;stop-opacity:0" />
            </radialGradient>
          </defs>

          <!-- 轨迹流线 -->
          <line x1="50" y1="120" x2="450" y2="120" stroke="#1e293b" stroke-width="1" stroke-dasharray="10,5" />

          <!-- 振荡几率曲线图 (背景微缩) -->
          <path :d="oscPath" fill="none" stroke="rgba(148, 163, 184, 0.2)" stroke-width="1" />

          <!-- 中微子本体 (变色球) -->
          <circle :cx="50 + dist * 4" cy="120" r="12" fill="url(#nu-grad)" filter="url(#glow)" />
          
          <!-- 虚影效果 (量子叠加感) -->
          <circle :cx="50 + dist * 4" cy="120" r="18" :fill="activeFlavor.hex" opacity="0.1" />
        </svg>

        <div class="physics-caption">
          <strong>物理规律：</strong>中微子的质量本征态与味本征态之间存在混合。这导致中微子在传播一段距离后，其检测到某种“味”的几率会随距离呈周期性变化。这证明了<strong>中微子具有微小而非零的质量</strong>。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row"><span class="label">模拟长基线飞行距离 (km)</span></div>
           <el-slider v-model="dist" :min="0" :max="100" size="small"></el-slider>
        </div>
        
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-refresh"></i>
           <p><strong>实战物理：</strong>这也是大亚湾中微子实验发现的第 3 种振荡模式的核心原理。<strong>观察：</strong>随着飞行距离增加，粒子的颜色在红、绿、蓝之间循环变换。这揭示了量子的<strong>身份不确定性</strong>及其与能量 $E$ 的复杂关联。
           </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'NeutrinoOscillationViz',
  data() {
    return {
      dist: 0,
      flavors: [
        { id: 0, name: '电子中微子 (νe)', color: 'rose', hex: '#f43f5e' },
        { id: 1, name: '缪中微子 (νμ)', color: 'emerald', hex: '#10b981' },
        { id: 2, name: '陶中微子 (ντ)', color: 'cyan', hex: '#06b6d4' }
      ]
    }
  },
  computed: {
    activeFlavor() {
       const mix = (this.dist / 33) % 3;
       return this.flavors[Math.floor(mix)];
    },
    oscPath() {
       let d = "M 50,120 ";
       for(let x=0; x<400; x+=5) {
          const y = 120 + Math.sin(x/20) * 40;
          d += `L ${50+x},${y} `;
       }
       return d;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.neutrino-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
